//@flow
import React, {useState} from 'react';

import {makeStyles} from '@material-ui/core';
import {useFormContext} from 'react-hook-form';

import CustomButton from '../../../../../../../elements/CustomButton/CustomButton';
import CustomTextField from '../../../../../../../elements/CustomTextField/CustomTextField';
import TextAndBackgroundColorSelector from '../../../../../../../elements/TextAndBackgroundColorSelector';

import {MAIN_BANNER_FIELDS} from '../constants';

import {useStoreColorSettings} from '../../../../../../ui/utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '1rem',
  },
  buttonPreview: {
    maxWidth: '25ch',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export default function BannerMainButton() {
  const classes = useStyles();

  const colorConfig = useStoreColorSettings();
  const {register, errors, setValue} = useFormContext();

  const [buttonText, setButtonText] = useState('');

  const textColorOptions = [
    {
      hex: '#FFFFFF',
      name: 'Blanco',
    },
    {
      hex: '#3A3A49',
      name: 'Negro',
    },
  ];

  return (
    <div className={classes.root}>
      <CustomTextField
        label=""
        // value={buttonText}
        onChange={e => setButtonText(e.target.value)}
        placeholder="Texto del botón (Max. 25 caracteres incluyendo espacios)"
        name={MAIN_BANNER_FIELDS.BUTTON_TEXT}
        inputRef={register({
          maxLength: {
            value: 25,
            message: 'Máximo 25 caracteres',
          },
        })}
        error={!!errors[MAIN_BANNER_FIELDS.BUTTON_TEXT]}
        helperText={
          errors[MAIN_BANNER_FIELDS.BUTTON_TEXT] &&
          errors[MAIN_BANNER_FIELDS.BUTTON_TEXT].message
        }
      />

      <TextAndBackgroundColorSelector
        arrayTextColors={textColorOptions}
        defaultTextColor="#3A3A49"
        defaultBackgroundColor={
          colorConfig && colorConfig.secondaryBackgroundColor
        }
        onChange={(textColor, bgColor) => {
          setValue(MAIN_BANNER_FIELDS.BUTTON_TEXT_COLOR, textColor);
          setValue(MAIN_BANNER_FIELDS.BUTTON_BACKGROUND_COLOR, bgColor);
        }}
        preview={(textColor, bgColor) => (
          <CustomButton
            style={{
              color: textColor,
              backgroundColor: bgColor,
            }}
            className={classes.buttonPreview}
            fullWidth
          >
            {buttonText || 'Botón'}
          </CustomButton>
        )}
      />
    </div>
  );
}
